/**
 * @file UserMobileCard.tsx
 * @description Card-вариант строки пользователя для mobile (phase08.5 shadcn).
 */

import type { ReactNode } from "react";

import { EditorialCard } from "./ui/EditorialCard";
import type { AdminUser } from "../lib/api-admin-users";

interface UserMobileCardProps {
  user: AdminUser;
  contextsLabel?: string;
  contextBadges: ReactNode;
  actions: ReactNode;
}

export function UserMobileCard({
  user,
  contextsLabel = "Контексты",
  contextBadges,
  actions,
}: UserMobileCardProps) {
  return (
    <EditorialCard>
      <EditorialCard.Body>
        <div className="flex flex-col gap-2">
          <div className="flex items-start justify-between gap-2">
            <div className="min-w-0">
              <div className="text-sm font-medium text-on-surface truncate">
                {user.displayName ?? user.email}
              </div>
              {user.displayName ? (
                <div className="text-xs text-on-surface-variant truncate">
                  {user.email}
                </div>
              ) : null}
              <div className="text-xs text-on-surface-muted mt-0.5">
                {new Date(user.createdAt).toLocaleDateString("ru-RU")}
                {!user.isActive ? " · деактивирован" : ""}
              </div>
            </div>
          </div>
          <div>
            <div data-slot="caption" className="text-xs uppercase tracking-wide text-on-surface-variant mb-1">
              {contextsLabel}
            </div>
            <div className="flex flex-wrap gap-1">{contextBadges}</div>
          </div>
          <div className="flex justify-end pt-2 border-t border-outline-variant">
            {actions}
          </div>
        </div>
      </EditorialCard.Body>
    </EditorialCard>
  );
}
